import __request__ from "routing/request";
export function createSearch(JSONbody, requestOptions) {
  return __request__("POST", "/views/search", JSONbody, {}, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  }, requestOptions);
}
export function createSearchV2(JSONbody, requestOptions) {
  return __request__("POST", "/views/search", JSONbody, {}, {
    "Accept": ["application/vnd.graylog.search.v2+json"]
  }, requestOptions);
}
export function getAllSearches(requestOptions) {
  return __request__("GET", "/views/search", null, {}, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  }, requestOptions);
}
export function cancelJob(jobId, requestOptions) {
  return __request__("DELETE", `/views/search/cancel/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function explainEffectiveQuery(JSONbody, requestOptions) {
  return __request__("POST", "/views/search/effective_query", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function jobStatus(jobId, page = 0, per_page = 0, requestOptions) {
  return __request__("GET", `/views/search/status/${jobId}`, null, { "page": page, "per_page": per_page }, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  }, requestOptions);
}
export function executeSyncJob(JSONbody, timeout = 6e4, requestOptions) {
  return __request__("POST", "/views/search/sync", JSONbody, { "timeout": timeout }, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  }, requestOptions);
}
export function executeSyncJobv2(JSONbody, timeout = 6e4, requestOptions) {
  return __request__("POST", "/views/search/sync", JSONbody, { "timeout": timeout }, {
    "Accept": ["application/vnd.graylog.search.v2+json"]
  }, requestOptions);
}
export function getSearch(id, requestOptions) {
  return __request__("GET", `/views/search/${id}`, null, {}, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  }, requestOptions);
}
export function executeQuery(id, JSONbody, requestOptions) {
  return __request__("POST", `/views/search/${id}/execute`, JSONbody, {}, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  }, requestOptions);
}
export function explainQuery(id, JSONbody, requestOptions) {
  return __request__("POST", `/views/search/${id}/explain`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
